
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Outstationurbaniaonrentpune() {



    const cardData =
    {
        keyword: 'Outstation Urbania On Rent Pune  ',
        heading: 'Amruta Travels: Outstation Urbania On Rent Pune  ',
        headingDescription: 'Amruta Travels offers Outstation Urbania On Rent in Pune, providing a comfortable and hassle-free travel solution for trips to nearby cities and tourist destinations. Perfect for family vacations, corporate tours, weekend getaways, and long-distance travel, our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures your outstation Urbania rental from Pune is safe, convenient, and enjoyable.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Outstation Urbania on rent Pune",
    "description": "Book Outstation Urbania on rent in Pune for comfortable and reliable travel to Lonavala, Mahabaleshwar, Shirdi, Goa, Mumbai, Nashik, and other destinations. Spacious seating, AC comfort, luggage space, cushioned interiors, and professional drivers ensure a smooth and safe outstation journey for families, corporate teams, and group travelers."
  },
  {
    "name": "Urbania on rent Pune for outstation",
    "description": "Urbania on rent in Pune for outstation trips with fully AC-equipped vehicles, luxury interiors, ample seating, and experienced drivers. Ideal for weekend getaways, corporate offsites, family outings, and long-distance travel across Maharashtra."
  },
  {
    "name": "Force Urbania outstation rental Pune",
    "description": "Force Urbania outstation rental in Pune for group travel, weddings, pilgrimages, and corporate trips. Enjoy smooth rides, air-conditioned comfort, luggage-friendly interiors, and professional drivers ensuring punctual and safe long-distance travel."
  },
  {
    "name": "Urbania van hire Pune outstation",
    "description": "Urbania van hire in Pune for outstation travel to destinations like Lonavala, Shirdi, Goa, Mumbai, and Nashik. Vehicles come with AC, spacious seating, cushioned interiors, and professional drivers for stress-free long-distance journeys."
  },
  {
    "name": "Force Urbania on rent Pune outstation",
    "description": "Book Force Urbania on rent in Pune for outstation trips, offering comfort, safety, and luxury. Ideal for family vacations, corporate travel, weekend getaways, and group pilgrimages. AC interiors, ample luggage space, cushioned seats, and expert drivers included."
  },
  {
    "name": "Urbania outstation hire Pune",
    "description": "Urbania outstation hire in Pune for small and medium-sized groups traveling to hill stations, beaches, or religious destinations. Fully AC, cushioned seating, smooth rides, ample luggage space, and professional drivers ensure a premium travel experience."
  },
  {
    "name": "Urbania rental Pune outstation trip",
    "description": "Urbania rental in Pune for outstation trips with luxury, comfort, and reliability. Ideal for corporate tours, family vacations, group outings, and long-distance travel. Vehicles equipped with AC, spacious seating, and professional chauffeurs."
  },
  {
    "name": "17 seater Urbania outstation rental Pune",
    "description": "17 seater Urbania outstation rental in Pune for large group trips to destinations like Lonavala, Mahabaleshwar, Shirdi, Goa, Mumbai, and Nashik. Offers AC interiors, spacious seating, luggage capacity, smooth rides, and professional drivers for safe long-distance journeys."
  },
  {
    "name": "13 seater Urbania outstation hire Pune",
    "description": "13 seater Urbania outstation hire in Pune for family trips, group outings, or corporate travel. Comfortable, AC-equipped, with cushioned interiors, ample luggage space, and experienced drivers ensuring a hassle-free journey."
  },
  {
    "name": "Luxury Urbania outstation hire Pune",
    "description": "Luxury Urbania outstation hire in Pune for premium travel experiences. Ideal for weddings, corporate trips, and weekend getaways. Fully AC interiors, spacious cushioned seating, luggage-friendly, and driven by professional chauffeurs."
  },
  {
    "name": "AC Urbania on rent Pune for outstation",
    "description": "AC Urbania on rent in Pune for outstation travel to scenic, religious, or business destinations. Ensures comfort, smooth rides, safety, luggage-friendly interiors, and professional drivers for a memorable long-distance journey."
  },
  {
    "name": "Outstation Urbania hire near me Pune",
    "description": "Find Outstation Urbania hire near you in Pune for local and long-distance trips. Vehicles come with AC, cushioned seating, ample luggage space, and experienced drivers for convenient and reliable outstation travel."
  },
  {
    "name": "Urbania outstation rental Pimpri Chinchwad",
    "description": "Urbania outstation rental in Pimpri Chinchwad for weekend trips, pilgrimages, family outings, or corporate travel. AC interiors, comfortable cushioned seating, luggage space, and professional drivers included."
  },
  {
    "name": "Urbania outstation hire Hinjewadi Pune",
    "description": "Urbania outstation hire in Hinjewadi Pune for IT professionals, corporate teams, and family travel. Smooth AC rides, comfortable seating, luggage-friendly interiors, and experienced drivers ensure stress-free journeys."
  },
  {
    "name": "Urbania outstation van Baner Pune",
    "description": "Urbania outstation van in Baner Pune for group travel, weddings, corporate outings, and long-distance trips. Vehicles equipped with AC, cushioned seating, ample luggage space, and professional drivers for reliable service."
  },
  {
    "name": "Urbania outstation rental Kharadi Pune",
    "description": "Urbania outstation rental in Kharadi Pune for weekend getaways, corporate trips, and family vacations. Luxury interiors, AC comfort, spacious seating, luggage space, and experienced chauffeurs for a smooth journey."
  },
  {
    "name": "Pune to Lonavala Urbania on rent",
    "description": "Book Urbania from Pune to Lonavala for a comfortable hill station trip. Spacious AC interiors, cushioned seating, luggage space, smooth ride, and professional drivers make your Lonavala journey relaxing and enjoyable."
  },
  {
    "name": "Pune to Mahabaleshwar Urbania hire",
    "description": "Hire Urbania from Pune to Mahabaleshwar for scenic trips. AC interiors, spacious seating, cushioned comfort, luggage space, and professional drivers for safe and hassle-free travel."
  },
  {
    "name": "Pune to Shirdi Urbania on rent",
    "description": "Urbania on rent from Pune to Shirdi for group pilgrimages and darshan trips. Comfortable AC interiors, spacious seating, luggage-friendly, smooth ride, and experienced drivers ensure a smooth and spiritual journey."
  },
  {
    "name": "Pune to Mumbai Urbania outstation cab",
    "description": "Travel from Pune to Mumbai with Urbania outstation cab services. Enjoy AC interiors, cushioned seats, luggage space, smooth rides, and professional drivers for corporate or family trips."
  },
  {
    "name": "Pune to Goa Urbania on rent",
    "description": "Book Urbania from Pune to Goa for long-distance leisure trips. Luxury interiors, AC comfort, spacious seating, luggage-friendly, and professional drivers for a safe and enjoyable journey."
  },
  {
    "name": "Pune to Nashik Urbania hire",
    "description": "Urbania hire from Pune to Nashik for pilgrimages, corporate outings, or group trips. AC interiors, cushioned seating, luggage space, smooth rides, and professional chauffeurs ensure comfortable travel."
  },
  {
    "name": "Urbania outstation rent Pune price",
    "description": "Check Urbania outstation rent in Pune for affordable and competitive pricing. Luxury interiors, AC comfort, cushioned seating, luggage-friendly vehicles, and professional drivers provided for all destinations."
  },
  {
    "name": "Urbania outstation hire Pune per km",
    "description": "Urbania outstation hire in Pune with per km rates for long-distance trips. Transparent pricing, luxury AC interiors, spacious seating, luggage space, and professional drivers ensure a comfortable journey."
  },
  {
    "name": "Affordable Urbania outstation rental Pune",
    "description": "Affordable Urbania outstation rental in Pune for families, corporate teams, and group travelers. AC interiors, cushioned seating, luggage-friendly vehicles, and professional drivers for safe and reliable travel."
  },
  {
    "name": "Best Urbania outstation service Pune",
    "description": "Best Urbania outstation service in Pune offering luxury, comfort, and reliability for group trips, family vacations, weddings, corporate tours, and religious travel. AC, cushioned interiors, luggage space, and professional drivers included."
  },
  {
    "name": "Cheap Urbania outstation hire Pune",
    "description": "Cheap Urbania outstation hire in Pune with competitive rates without compromising comfort or safety. AC interiors, cushioned seating, ample luggage space, and professional drivers provided."
  },
  {
    "name": "Book outstation Urbania Pune",
    "description": "Book outstation Urbania in Pune easily online for long-distance trips, corporate tours, family vacations, weddings, and pilgrimages. Spacious AC interiors, luggage-friendly, cushioned seating, and professional drivers ensure smooth travel."
  },
  {
    "name": "Online Urbania outstation booking Pune",
    "description": "Online booking of Urbania for outstation trips from Pune. Convenient, reliable, and safe service with AC comfort, cushioned seating, ample luggage space, and professional drivers for long-distance travel."
  },
  {
    "name": "Force Urbania outstation booking Pune",
    "description": "Force Urbania outstation booking in Pune for corporate trips, weddings, and group travel. Fully AC interiors, cushioned seats, luggage-friendly, and professional drivers ensure a safe and luxurious journey."
  },
  {
    "name": "17 Seater Outstation Urbania On Rent in Pune",
    "description": "17 Seater Outstation Urbania on rent in Pune for large group trips to Lonavala, Mahabaleshwar, Shirdi, Goa, Mumbai, and Nashik. AC interiors, spacious seating, luggage space, smooth ride, and professional drivers included."
  },
  {
    "name": "Luxury Force Urbania Outstation Hire Pune",
    "description": "Luxury Force Urbania outstation hire in Pune for premium long-distance travel. AC interiors, cushioned seating, luggage-friendly, professional chauffeurs, and smooth rides for weddings, corporate trips, and family outings."
  },
  {
    "name": "Urbania Outstation Cab Service Pune",
    "description": "Urbania outstation cab service in Pune for weekend trips, pilgrimages, corporate travel, and group outings. AC interiors, cushioned seating, ample luggage space, smooth rides, and professional drivers provided."
  }
],
"tableData": [
  ["Outstation Urbania on rent Pune", "Urbania on rent Pune for outstation"],
  ["Force Urbania outstation rental Pune", "Urbania van hire Pune outstation"],
  ["Force Urbania on rent Pune outstation", "Urbania outstation hire Pune"],
  ["Urbania rental Pune outstation trip", "17 seater Urbania outstation rental Pune"],
  ["13 seater Urbania outstation hire Pune", "Luxury Urbania outstation hire Pune"],
  ["AC Urbania on rent Pune for outstation", "Outstation Urbania hire near me Pune"],
  ["Urbania outstation rental Pimpri Chinchwad", "Urbania outstation hire Hinjewadi Pune"],
  ["Urbania outstation van Baner Pune", "Urbania outstation rental Kharadi Pune"],
  ["Pune to Lonavala Urbania on rent", "Pune to Mahabaleshwar Urbania hire"],
  ["Pune to Shirdi Urbania on rent", "Pune to Mumbai Urbania outstation cab"],
  ["Pune to Goa Urbania on rent", "Pune to Nashik Urbania hire"],
  ["Urbania outstation rent Pune price", "Urbania outstation hire Pune per km"],
  ["Affordable Urbania outstation rental Pune", "Best Urbania outstation service Pune"],
  ["Cheap Urbania outstation hire Pune", "Book outstation Urbania Pune"],
  ["Online Urbania outstation booking Pune", "Force Urbania outstation booking Pune"],
  ["17 Seater Outstation Urbania On Rent in Pune", "Luxury Force Urbania Outstation Hire Pune"],
  ["Urbania Outstation Cab Service Pune", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable Urbania for Outstation Travel",
    "WhyChoosedescription": "Amruta Travels offers Outstation Urbania On Rent in Pune, combining luxury, comfort, and reliability. Perfect for small to medium-sized groups, it ensures a smooth and premium travel experience for long-distance journeys."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Trips, Family Outings, and VIP Travel",
    "WhyChoosedescription": "Whether it’s a corporate trip, family vacation, or VIP transport, renting an Urbania for outstation travel guarantees a spacious, comfortable, and stylish journey across cities."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "The Urbania features plush seating, generous legroom, air conditioning, large windows, and ample luggage space, making it perfect for long journeys, weekend getaways, and outstation tours."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure a smooth, safe, and punctual journey. Skilled in handling the Urbania, they provide professional and courteous service for all outstation trips."
  },
  {
    "WhyChooseheading": "Transparent Pricing and Affordable Luxury",
    "WhyChoosedescription": "Enjoy the luxury of the Urbania at competitive rates. Amruta Travels provides clear, upfront pricing with no hidden charges, ensuring excellent value for outstation travel."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All Urbania vehicles are regularly serviced and sanitized, maintaining the highest standards of safety, hygiene, and comfort for long-distance journeys."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We provide customized travel routes, multiple pickup/drop-off points, and flexible scheduling to suit your outstation itinerary and ensure a hassle-free journey."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania for outstation travel in Pune is hassle-free. Our friendly support team assists you at every step, ensuring a smooth and seamless experience from start to finish."
  }
]

    }

const faqData = [
  {
    question: 'How can I rent an Urbania for outstation trips from Pune?',
    answer: 'Renting an Urbania for outstation trips is easy with Amruta Travels. You can book online, call our support team, or visit our office. We will help you select the best vehicle for your journey.'
  },
  {
    question: 'What makes the Urbania suitable for outstation travel?',
    answer: 'The Urbania offers comfortable seating, air conditioning, spacious interiors, large windows, and ample luggage space—perfect for long-distance journeys and city-to-city travel.'
  },
  {
    question: 'Can the Urbania accommodate long-distance travel safely?',
    answer: 'Yes, the Urbania is designed for both local and long-distance travel. It ensures stability, safety, and comfort throughout the journey, making it ideal for outstation trips.'
  },
  {
    question: 'Does the rental include a driver for outstation trips?',
    answer: 'Yes, every outstation Urbania rental comes with a professional, experienced driver who ensures safety, punctuality, and a smooth journey.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained for long trips?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, sanitized, and maintained to ensure maximum comfort, safety, and reliability for long-distance travel.'
  },
  {
    question: 'What is the cost of renting an Urbania for outstation trips?',
    answer: 'The rental cost depends on trip duration, distance, and additional services. Contact Amruta Travels for a customized and transparent quote tailored to your itinerary.'
  },
  {
    question: 'Can I customize pickup and drop-off points for my outstation journey?',
    answer: 'Yes, we provide flexible pickup and drop-off options and can customize the route according to your schedule and travel plan.'
  },
  {
    question: 'Why choose Amruta Travels for Outstation Urbania rentals in Pune?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and dedicated support, ensuring a safe, comfortable, and premium outstation travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ajay Kulkarni',
    role: 'Corporate Manager, Pune',
    text: 'We rented an Urbania for an outstation corporate trip. The vehicle was spacious, clean, and extremely comfortable. The driver was professional and punctual. Excellent service from Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Patil',
    role: 'Event Organizer, Pune',
    text: 'Booked an Urbania for a weekend outstation family trip. The ride was smooth, the vehicle luxurious, and the driver courteous. Highly recommend Amruta Travels for long trips!',
    rating: 5
  }
];
















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Urbania On Rent Pune",
  "image": "https://bushireinpune.com/assets/images/outstation-urbania-on-rent-pune.jpg",
  "description": "Hire Outstation Urbania on rent in Pune with Amruta Travels for long-distance travel and multi-day trips. Luxury AC Force Urbania vans available in 13 and 17 seater options for outstation journeys from Pune to Lonavala, Mahabaleshwar, Shirdi, Mumbai, Goa, Nashik, and more. Affordable per km pricing with professional drivers. Service available in Pimpri Chinchwad, Hinjewadi, Baner, Kharadi, and across Pune city.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3150"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/outstation-urbania-on-rent-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Outstation Urbania On Rent Pune | Force Urbania Hire</title>
  <meta
    name="description"
    content="Outstation Urbania on rent in Pune with Amruta Travels. Hire luxury 13 & 17 seater Force Urbania vans for trips to Lonavala, Mahabaleshwar, Shirdi, Mumbai, Goa & Nashik at best per km rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/103.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Outstationurbaniaonrentpune;